import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { translate } from '@/i18n';
import { useSettingsStore } from '@/store/modules/settings';

import { inject, reactive, ref, onBeforeUnmount } from 'vue';
import { storeToRefs } from 'pinia';
import { useCssVar } from '@vueuse/core';
export default /*@__PURE__*/_defineComponent({
  __name: 'VabThemeDrawer',
  setup(__props) {
    const $sub = inject('$sub');
    const $unsub = inject('$unsub');
    const $baseLoading = inject('$baseLoading');
    const settingsStore = useSettingsStore();
    const {
      theme,
      device
    } = storeToRefs(settingsStore);
    const {
      saveTheme,
      resetTheme,
      updateTheme
    } = settingsStore;
    const state = reactive({
      drawerVisible: false
    });
    const handleOpenTheme = () => {
      state.drawerVisible = true;
    };
    const updateMenuWidth = () => {
      useCssVar('--el-left-menu-width', ref(null)).value = theme.value.menuWidth;
    };
    const setDefaultTheme = async () => {
      await resetTheme();
      await updateTheme();
      state.drawerVisible = false;
      if (document.body.getBoundingClientRect().width - 1 < 480) location.reload();
    };
    const handleSaveTheme = async () => {
      await saveTheme();
      state.drawerVisible = false;
      if (document.body.getBoundingClientRect().width - 1 < 480) location.reload();
    };
    const shuffle = (val, list) => list.filter(_ => _ !== val)[Math.random() * (list.length - 1) | 0];
    const randomTheme = async () => {
      const loading = $baseLoading(0);
      // 随机换肤重置移除主题，防止代码更新影响样式
      await resetTheme();
      theme.value.themeName = shuffle(theme.value.themeName, ['blue-black', 'blue-white', 'ocean', 'green-black', 'green-white', 'purple-black', 'purple-white', 'red-black', 'red-white']);
      theme.value.columnStyle = shuffle(theme.value.columnStyle, ['vertical', 'horizontal', 'card', 'arrow']);
      // theme.value.background = shuffle(theme.value.background, [
      //   'none',
      //   'vab-background',
      // ])
      theme.value.tabsBarStyle = shuffle(theme.value.tabsBarStyle, ['card', 'smart', 'smooth']);
      theme.value.showTabsIcon = shuffle(theme.value.showTabsIcon, [true, false]);
      theme.value.layout = device.value === 'desktop' ? shuffle(theme.value.layout, ['horizontal', 'vertical', 'column', 'comprehensive', 'common', 'float']) : 'vertical';
      try {
        await updateTheme();
        await saveTheme();
      } finally {
        setTimeout(() => {
          loading.close();
        }, 1000);
      }
    };
    $sub('theme', () => {
      handleOpenTheme();
    });
    $sub('random-theme', () => {
      randomTheme();
    });
    onBeforeUnmount(() => {
      $unsub('theme');
      $unsub('random-theme');
    });
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createBlock(_component_el_drawer, {
        modelValue: _unref(state).drawerVisible,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(state).drawerVisible = $event),
        "append-to-body": "",
        class: "vab-drawer",
        direction: "rtl",
        size: "285px",
        title: _unref(translate)('主题配置')
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSaveTheme
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)('保存')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: setDefaultTheme
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)('恢复默认')), 1)]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          height: "88vh"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form, {
            ref: "form",
            "label-position": "left",
            model: _unref(theme)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)('布局')) + " ", 1), _createVNode(_component_el_tooltip, {
                content: _unref(translate)('布局配置仅' + '在电脑视窗下生效，手机视窗时将' + '默认锁定为纵向布局'),
                effect: "dark",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_vab_icon, {
                  icon: "question-line"
                })]),
                _: 1
              }, 8, ["content"])]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(theme).layout,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(theme).layout = $event),
                disabled: _unref(device) === 'mobile',
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  key: "column",
                  label: _unref(translate)('分栏'),
                  value: "column"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "comprehensive",
                  label: _unref(translate)('综合'),
                  value: "comprehensive"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "vertical",
                  label: _unref(translate)('纵向'),
                  value: "vertical"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "horizontal",
                  label: _unref(translate)('横向'),
                  value: "horizontal"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "common",
                  label: _unref(translate)('常规'),
                  value: "common"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "float",
                  label: _unref(translate)('浮动'),
                  value: "float"
                }, null, 8, ["label"])]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: _unref(translate)('主题')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(theme).themeName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(theme).themeName = $event),
                onChange: _unref(updateTheme)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  key: "blue-black",
                  label: _unref(translate)('蓝黑'),
                  value: "blue-black"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "blue-white",
                  label: _unref(translate)('蓝白'),
                  value: "blue-white"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "green-black",
                  label: _unref(translate)('绿黑'),
                  value: "green-black"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "green-white",
                  label: _unref(translate)('绿白'),
                  value: "green-white"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "purple-black",
                  label: _unref(translate)('紫黑'),
                  value: "purple-black"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "purple-white",
                  label: _unref(translate)('紫白'),
                  value: "purple-white"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "red-black",
                  label: _unref(translate)('红黑'),
                  value: "red-black"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "red-white",
                  label: _unref(translate)('红白'),
                  value: "red-white"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "ocean",
                  label: _unref(translate)('渐变'),
                  value: "ocean"
                }, null, 8, ["label"])]),
                _: 1
              }, 8, ["modelValue", "onChange"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              class: "vab-item-custom"
            }, {
              label: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)('菜单背景')) + " ", 1), _createVNode(_component_el_tooltip, {
                content: _unref(translate)('支持纵向布局' + '、分栏布局、综合' + '布局、常规布局，不支持横' + '向布局、浮动' + '布局'),
                effect: "dark",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_vab_icon, {
                  icon: "question-line"
                })]),
                _: 1
              }, 8, ["content"])]),
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: _unref(theme).background,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(theme).background = $event),
                disabled: _unref(theme).layout === 'float' || _unref(theme).layout === 'horizontal',
                onChange: _unref(updateTheme)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_button, {
                  class: "none",
                  label: "none"
                }), _createVNode(_component_el_radio_button, {
                  class: "vab-background",
                  label: "vab-background"
                })]),
                _: 1
              }, 8, ["modelValue", "disabled", "onChange"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: _unref(translate)('菜单宽度')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(theme).menuWidth,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(theme).menuWidth = $event),
                disabled: _unref(theme).layout === 'float' || _unref(theme).layout === 'horizontal',
                onChange: updateMenuWidth
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  key: "266px",
                  label: "266px",
                  value: "266px"
                }), _createVNode(_component_el_option, {
                  key: "277px",
                  label: "277px",
                  value: "277px"
                }), _createVNode(_component_el_option, {
                  key: "288px",
                  label: "288px",
                  value: "288px"
                })]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('标签')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showTabs,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(theme).showTabs = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)('标签图标')) + " ", 1), _createVNode(_component_el_tooltip, {
                content: _unref(translate)('标签开启时生效'),
                effect: "dark",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_vab_icon, {
                  icon: "question-line"
                })]),
                _: 1
              }, 8, ["content"])]),
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showTabsIcon,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(theme).showTabsIcon = $event),
                disabled: !_unref(theme).showTabs
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)('标签风格')) + " ", 1), _createVNode(_component_el_tooltip, {
                content: _unref(translate)('标签开启时生效'),
                effect: "dark",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_vab_icon, {
                  icon: "question-line"
                })]),
                _: 1
              }, 8, ["content"])]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(theme).tabsBarStyle,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(theme).tabsBarStyle = $event),
                disabled: !_unref(theme).showTabs
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  key: "card",
                  label: _unref(translate)('卡片'),
                  value: "card"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "smart",
                  label: _unref(translate)('灵动'),
                  value: "smart"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "smooth",
                  label: _unref(translate)('圆滑'),
                  value: "smooth"
                }, null, 8, ["label"])]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)('分栏风格')) + " ", 1), _createVNode(_component_el_tooltip, {
                content: _unref(translate)('分栏布局时生效'),
                effect: "dark",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(_component_vab_icon, {
                  icon: "question-line"
                })]),
                _: 1
              }, 8, ["content"])]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(theme).columnStyle,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(theme).columnStyle = $event),
                disabled: _unref(theme).layout !== 'column'
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  key: "vertical",
                  label: _unref(translate)('纵向'),
                  value: "vertical"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "horizontal",
                  label: _unref(translate)('横向'),
                  value: "horizontal"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "card",
                  label: _unref(translate)('卡片'),
                  value: "card"
                }, null, 8, ["label"]), _createVNode(_component_el_option, {
                  key: "arrow",
                  label: _unref(translate)('箭头'),
                  value: "arrow"
                }, null, 8, ["label"])]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: _unref(translate)('头部固定')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).fixedHeader,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(theme).fixedHeader = $event),
                disabled: _unref(theme).layout === 'common'
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('国际化')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showLanguage,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(theme).showLanguage = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('进度条')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showProgressBar,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(theme).showProgressBar = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('刷新')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showRefresh,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(theme).showRefresh = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('搜索')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showSearch,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(theme).showSearch = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('通知')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showNotice,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(theme).showNotice = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('全屏')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showFullScreen,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(theme).showFullScreen = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('锁屏')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showLock,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(theme).showLock = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_form_item, {
              label: _unref(translate)('页面动画')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                modelValue: _unref(theme).showPageTransition,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(theme).showPageTransition = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
});